import React from 'react';
import logo from '../assets/logo.png';
import EersteStappen from './EersteStappen';

const Home = ({ currentUser, onNavigate, onLogout }) => {
    const { role, username, email } = currentUser;

    // Helper to check permissions
    const hasRole = (roles) => roles.includes(role);

    // Tiles Configuration
    // Tiles Configuration with explicit inline styles
    const tiles = [
        {
            id: 'admin_dashboard',
            title: 'Beheerders Dashboard',
            description: 'Beheer gebruikers, locaties, componenten en instellingen.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            visible: hasRole(['admin', 'superuser']),
            action: () => onNavigate('admin_dashboard'),
            bgColor: '#334155' // slate-700
        },
        {
            id: 'wizard',
            title: 'Nieuw Werkplan',
            description: 'Start een nieuwe LOTO-procedure of werkvergunning.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
            ),
            visible: hasRole(['admin', 'superuser', 'werkvoorbereider', 'wv']),
            action: () => onNavigate('wizard', true), // true = reset session
            bgColor: '#2563eb' // blue-600
        },
        {
            id: 'applicant_dashboard',
            title: 'Aanvragen Beheren',
            description: 'Bekijk en beheer uw openstaande aanvragen.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
            ),
            visible: hasRole(['werkvoorbereider', 'wv']),
            action: () => onNavigate('applicant_dashboard'),
            bgColor: '#4f46e5' // indigo-600
        },
        {
            id: 'monteur_dashboard',
            title: 'Mijn Taken',
            description: 'Overzicht van toegewezen werkplannen en LOTO-taken.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
            ),
            visible: hasRole(['monteur', 'admin', 'superuser']),
            action: () => onNavigate('monteur_dashboard'),
            bgColor: '#0d9488' // teal-600
        },
        {
            id: 'tech_doc_dashboard',
            title: 'Tech Doc Quality',
            description: 'Beheer meldingen over tekeningen en labels.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
            ),
            visible: hasRole(['tech_doc', 'wv', 'admin', 'superuser']),
            action: () => onNavigate('tech_doc_dashboard'),
            bgColor: '#d97706' // amber-600
        },
        {
            id: 'active_loto',
            title: 'Active LOTO Dashboard',
            description: 'Live overzicht van alle actieve vergrendelingen.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
            ),
            visible: true,
            action: () => onNavigate('active_loto_dashboard'),
            bgColor: '#dc2626' // red-600
        },
        {
            id: 'kennis_kluis',
            title: 'Kennis-Kluis AI',
            description: 'AI-gestuurde kennisbank: stel vragen over handleidingen en storingen.',
            icon: (
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
            ),
            visible: hasRole(['superuser']),
            action: () => onNavigate('kennis_kluis'),
            bgColor: '#7c3aed' // violet-600
        }
    ];

    return (
        <div className="min-h-screen flex flex-col">
            {/* Header */}
            <header className="rw-appbar">
                <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <img src={logo} alt="RaconWorks" style={{ height: '2rem' }} className="object-contain" />
                        <span className="font-bold" style={{ letterSpacing: '.02em' }}>RaconWorks</span>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="text-right hidden sm:block" style={{ lineHeight: 1.25 }}>
                            <p className="text-sm font-bold">{username}</p>
                            <span className="rw-rolechip">{role}</span>
                        </div>
                        <button onClick={onLogout} className="btn btn-secondary btn-sm">Uitloggen</button>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 max-w-7xl w-full mx-auto px-4 py-10">
                <div className="mb-8">
                    <h2 className="text-2xl font-bold mb-1">Welkom, {username}</h2>
                    <p className="text-slate-400">Wat wilt u vandaag doen?</p>
                </div>

                
                <EersteStappen currentUser={currentUser} onNavigate={onNavigate} />
<div className="rw-tiles">
                    {tiles.filter(t => t.visible).map(tile => (
                        <button key={tile.id} onClick={tile.action} className="rw-tile">
                            <span className="rw-tile-ico">{tile.icon}</span>
                            <span>
                                <span className="rw-tile-title">{tile.title}</span>
                                <span className="rw-tile-desc">{tile.description}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </main>

            {/* Footer */}
            <footer className="text-center py-8 text-slate-500 text-xs">
                <p>&copy; {new Date().getFullYear()} RaconWorks</p>
            </footer>
        </div>
    );
};

export default Home;
